<!--
/*
 * @Description: 使用账号密码登录
 * @Author: Guojun
 * @Date: 2020-05-19 14:43:48
 * @LastEditTime: 2020-5-20 09:02:47
 */
  -->
<template>
  <div class="passwordLogin" >
    <el-form ref="loginForm" :model="loginForm" :rules="rules">
      <el-form-item prop="name">
        <img class="icon" src="@/assets/images/username.png" alt />
        <el-input placeholder="请输入手机号" v-model.number="loginForm.name"  @keyup.enter.native="login()" maxlength="11"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <img class="icon" src="@/assets/images/password.png" alt />
        <el-input placeholder="请输入密码" type="password" v-model="loginForm.password"  @keyup.enter.native="login()" maxlength="16"></el-input>
      </el-form-item>
      <el-form-item class="btn">
        <el-button @click.prevent="login()" class="loginBtn">登录</el-button>
      </el-form-item>
      <div class="hint">
        <span class="register" @click="register()">注册新用户</span>
        <span @click="forgetPassword">忘记密码</span>
      </div>
    </el-form>
  </div>
</template>
<script>
import Vue from "vue";
import phoneLogin from "./phoneLogin.vue";
import user from "../apis/user_apis";
import utils from "../utils/utils";
import { loginRules } from "../validate/rules";
export default {
  data() {
    return {
      show: false,
      loginForm: {
        name: "",
        password: "",
      },
      checked: false,
      picCode: 0,
      codeImg: "",
      req_time: "",
      rules: loginRules,
      activeTab: 0,
      tabs: ["手机快捷登录", "账号密码登录"],
      captcha:'',
    };
  },
  created() {
  },
  mounted() {
    this.$EventBus.$on("verfySuccess", (data) => {
      console.log("监测success");
      this.captcha = data;
      this.req_time = new Date().getTime();
      this.loginFun();
    });
  },
  beforeDestroy(){
    this.$EventBus.$off('verfySuccess')
  },
  methods: {
    login() { 
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$EventBus.$emit("slideShow", true);
        } else {
          return false;
        }
      });
    },
    // 登录接口调取
    loginFun(){
      let that = this;
      user.login(that).then((res) => {
          if (res.success) {
            let account = {
              name: that.loginForm.name,
              password: that.loginForm.password,
            };
            utils.setCookie("TOKEN", res.data.token);
            utils.setCookie("USER_INFO",res.data.mobile);
            this.$store.commit("USER_INFO",res.data.mobile);
            this.$parent.show = false;
            this.$router.push({
              path: "/index",
            });
            window.location.reload();
          } else {
            console.log("登录失败")
          }
        });
    },
    // 注册
    register() {
      this.$router.push({
        path: "/register",
      });
      this.$EventBus.$emit("close", false);
    },
    // 忘记密码
    forgetPassword() {
      this.$router.push({
        path: "/getPswd",
      });
       this.$EventBus.$emit("close", false);
    },
    tabsClick(index) {
      this.activeTab = index;
    },
    //获取手机验证码
    getCode() {
      let that = this;
      that.$refs.phoneRules.validateField("phone", (valid) => {
        that.$refs.phoneRules.validateField("picutureCode", (valid1) => {
          if (!valid && !valid1) {
            if (that.sendMsgDisabled) {
              user.getMessageCode(this, this.loginForm).then((res) => {
                if (res.success) {
                  that.sendMsgDisabled = false;
                  that.$message({
                    message: "验证码10分钟有效",
                    type: "success",
                  });
                  that.timer = setInterval(() => {
                    that.second--;
                    if (that.second <= 0) {
                      clearTimeout(that.timer);
                      that.sendMsgDisabled = true;
                      that.second = 60;
                      that.code_text = "重新获取";
                    }
                  }, 1000);
                }
              });
            } else {
              return;
            }
          } else {
            return false;
          }
        });
      });
    },
  },
  components: {
    phoneLogin,
  },
};
</script>
 
<style lang="less" scoped>
.passwordLogin {
  .hint {
    display: flex;
    justify-content: space-between;
    margin-top: 22px;
    margin-bottom: 65px;
    color: #999999;
    font-size: 12px;
    cursor: pointer;

    .register {
      color: #fabe00;
    }
  }
  .el-form-item {
    height: 60px;
    margin-bottom: 0px !important;
    position: relative;

    .icon {
      width: 20px;
      height: 20px;
      position: absolute;
      z-index: 22;
      bottom: 11px;
    }

    .last-icon {
      width: 23px;
      height: 14px;
      position: absolute;
      z-index: 22;
      bottom: 11px;
      right: 0;
    }
  }
  .getCode {
    position: absolute;
    right: 0;
    bottom: 8px;
    display: inline-block;
    width: 80px;
    height: 30px;
    line-height: 36px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    background: #9f9f9f;
    border-radius: 4px;
    cursor: pointer;
  }
  /deep/ .el-input__inner {
    height: 35px;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #e9e9f0;
    padding: 0 35px;
  }
  /deep/ .el-input__inner:focus {
    caret-color: #fabe00;
    border-bottom-color: #fabe00;
  }
  /deep/ .el-form-item__label {
    height: 50px !important;
    text-align: left !important;
    line-height: 50px !important;
    border-bottom: 1px solid #e9e9f0 !important;
  }
  .btn {
    margin-top: 20px;
    height: auto;

    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  /deep/ .el-button + .el-button {
    margin-left: 30px !important;
  }
  /deep/ .el-button {
    padding: 0;
    width: 300px;
    height: 41px;
    font-size: 14px;
    border: 1px solid rgba(250, 217, 0, 1);
    color: #333;
    font-weight: normal;
    border-radius: 2px;
    background: linear-gradient(
      90deg,
      rgba(250, 217, 0, 1) 0%,
      rgba(250, 190, 0, 1) 100%
    );
    box-shadow: 0px 3px 12px rgba(250, 190, 0, 0.5);
  }
  /deep/ .el-button:hover {
    color: #fff;
    background: rgba(252, 111, 25, 1);
    box-shadow: 0px 3px 12px rgba(250, 108, 0, 0.3);
  }
  /deep/ .el-checkbox__inner {
    border: 1px solid #808495;
  }
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
    border: 1px solid #dcdfe6;
  }
}
</style>